import { createAsyncThunk } from '@reduxjs/toolkit';

import sendRequest from '../../../service/sendRequest';
import consumerApi, { AUTH_SHAPE } from '../../../service/consumerApi';
import { enqueueSnackbar, somethingWrongNotification } from '../../notifier/notifierActions';
import { clearConsumerSession, setConsumerSession } from '../consumerReducer';
import { pickCredentials } from '../consumerSession';
import { PROJECT_TYPES } from '../../../constants';
import { openProject } from '../../global/globalReducer';

const GET_CONSUMER_ACTIV8_DATA = 'consumer/activ8/GET_CONSUMER_ACTIV8_DATA';
const FIND_CONSUMER_ACTIV8_CONTENT = 'consumer/activ8/FIND_CONSUMER_ACTIV8_CONTENT';
const GET_CONSUMER_ACTIV8_TAGS = 'consumer/activ8/GET_CONSUMER_ACTIV8_TAGS';
const LIKE_CONSUMER_ACTIV8_CONTENT = 'consumer/activ8/LIKE_CONSUMER_ACTIV8_CONTENT';

export const getConsumerActiv8Data = createAsyncThunk(
  GET_CONSUMER_ACTIV8_DATA,
  async ({ projectName, projectPassword }, { dispatch, rejectWithValue }) => {
    const response = await sendRequest(
      () =>
        consumerApi.post(`/api/consumer/activ8`, null, {
          authShape: AUTH_SHAPE.FLAT,
          consumerCredentials: { projectName, projectPassword },
        }),
      {
        onError: (e) => defaultErrorHandler(e, dispatch, rejectWithValue),
      },
    );

    dispatch(
      setConsumerSession({
        projectType: PROJECT_TYPES.ACTIV8,
        projectName,
        projectPassword,
      }),
    );

    dispatch(openProject(projectName));

    return response.data;
  },
);

export const findConsumerActiv8Content = createAsyncThunk(
  FIND_CONSUMER_ACTIV8_CONTENT,
  async (_, { rejectWithValue, getState }) => {
    if (!pickCredentials(getState().consumer.session)) {
      return rejectWithValue(null);
    }

    const { page, size, searchQuery, filters } = getState().activ8.tableSettings;
    const requestBody = { page, size, searchQuery, filters };

    // TODO: wire consumerApi PROJECT_REQUEST when Activ8 consumer content API is ready
    void requestBody;
  },
);

export const findConsumerActiv8Tags = createAsyncThunk(
  GET_CONSUMER_ACTIV8_TAGS,
  async ({ query }, { rejectWithValue, getState }) => {
    if (!pickCredentials(getState().consumer.session)) {
      return rejectWithValue(null);
    }

    const requestBody = { query };

    // TODO: wire consumerApi when Activ8 consumer tags API is ready
    void requestBody;
  },
);

export const likeConsumerActiv8Content = createAsyncThunk(
  LIKE_CONSUMER_ACTIV8_CONTENT,
  async ({ id, reaction }, { rejectWithValue, getState }) => {
    if (!pickCredentials(getState().consumer.session)) {
      return rejectWithValue(null);
    }

    const requestBody = { id, ...(reaction ? { reaction } : {}) };

    // TODO: wire consumerApi when Activ8 consumer react API is ready
    void requestBody;
  },
);

const defaultErrorHandler = (e, dispatch, rejectWithValue) => {
  if (e.response.status === 409) {
    dispatch(
      enqueueSnackbar({
        message: 'projectInUse',
        options: {
          variant: 'warning',
          subMessage: 'thisProjectIsCurrentlyUsing',
          subMessageParams: {
            username: e.response.data.username ?? '',
          },
        },
      }),
    );
    dispatch(clearConsumerSession());

    return rejectWithValue(e);
  }

  dispatch(somethingWrongNotification());
  return rejectWithValue(e);
};
